export default __webpack_public_path__ + "static/media/i031vp.d5196635.webp";